import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Inicio = () => import('@/views/pages/Home')
const Login = () => import('@/views/pages/Login')
// const LoginCliente = () => import('@/views/pages/LoginCliente')
const Auth = () => import('@/views/pages/Auth')
const Register = () => import('@/views/pages/Register')
const ResetPassword = () => import('@/views/pages/Reset')
const ForgotPassword = () => import('@/views/pages/Forgot')
const SearchList = () => import('@/views/searchList/List')

const Bancos = () => import('@/views/bancos/List')
const BancoAdd = () => import('@/views/bancos/ABM')
const BancoEdit = () => import('@/views/bancos/ABM')
const BancoDatos = () => import('@/views/bancos/Data')
const Clientes = () => import('@/views/clientes/List')
const ClienteAdd = () => import('@/views/clientes/ABM')
const ClienteEdit = () => import('@/views/clientes/ABM')
const Dashboard = () => import('@/views/Dashboard')
const Eventos = () => import('@/views/eventos/List')
const EventoAdd = () => import('@/views/eventos/ABM')
const EventoEdit = () => import('@/views/eventos/ABM')
const EventoDuplicar = () => import('@/views/eventos/ABM')
const EventoCodigosPromocion = () => import('@/views/eventos/CodigosPromocion')
const EventoDatos = () => import('@/views/eventos/Data')
const EventoProof = () => import('@/views/eventos/Imagenes')
const EventoStatus = () => import('@/views/eventos/Status')
const EventosEtapas = () => import('@/views/eventosEtapas/List')
const EventoEtapaAdd = () => import('@/views/eventosEtapas/ABM')
const EventoEtapaEdit = () => import('@/views/eventosEtapas/ABM')
const EventoEtapaDatos = () => import('@/views/eventosEtapas/Data')
const Ganadores = () => import('@/views/eventos/Ganadores')
const ImportMontosTransferir = () => import('@/views/edi/ImportMontosTransferir');
const ImportsParticipantes = () => import('@/views/importParticipantes/List');
const ImportParticipantes = () => import('@/views/importParticipantes/Participantes');
const ImportParticipante = () => import('@/views/importParticipantes/Participante');
const Participantes = () => import('@/views/participantes/List')
const ParticipanteAdd = () => import('@/views/participantes/ABM')
const ParticipanteReinscripcion = () => import('@/views/participantes/Reinscripcion')
const ParticipanteReinscripcionConfirmacion = () => import('@/views/participantes/ReinscripcionConfirmacion')
const ParticipanteEdit = () => import('@/views/participantes/ABM')
const ParticipanteDatos = () => import('@/views/participantes/Data')
const ParticipanteEtapa = () => import('@/views/participantes/Etapa')
const ParticipanteTransferenciaDatos = () => import('@/views/transferencias/Data')
const ParticipantesSorteo = () => import('@/views/participantes/ListSorteo')
const ImportTransferenciasFile = () => import('@/views/importTransferencias/ImportFile')
const ImportTransferenciasParticipantes = () => import('@/views/importTransferencias/ImportTransferenciasParticipantes')
const ExportTransferencias = () => import('@/views/exportTransferencias/List')
const ExportTransferenciasDatos = () => import('@/views/exportTransferencias/Data')
const ResultadosSorteo = () => import('@/views/sorteos/Resultados')
const ResultadosSorteoGlobalSorteo = () => import('@/views/sorteos/Resultados')
const Staff = () => import('@/views/staff/List')
const StaffAdd = () => import('@/views/staff/ABM')
const StaffEdit = () => import('@/views/staff/ABM')
const StaffDatos = () => import('@/views/staff/Data')
const SorteosGlobales = () => import('@/views/sorteosglobales/List')
const SorteoGlobalABM = () => import('@/views/sorteosglobales/ABM')
const SorteoGlobalDatos = () => import('@/views/sorteosglobales/Data')
const SorteoGlobalEventos = () => import('@/views/sorteosglobales/Eventos')
const Usuarios = () => import('@/views/usuarios/List')
const UsuarioABM = () => import('@/views/usuarios/ABM')
const UsuarioDatos = () => import('@/views/usuarios/Data')
const UsuarioPWA = () => import('@/views/usuariosPWA/UsuarioPWA')
const UsuarioVeraz = () => import('@/views/usuariosVeraz/UsuarioVeraz')
const Perfil = () => import('@/views/usuarios/Perfil')
const Pass = () => import('@/views/usuarios/Pass')

Vue.use(Router)

function requireAuth (to, from, next) {
  let loggedIn = (/true/i).test(store.getters['user/loggedIn']);

  if (loggedIn) {
    next ();
  } else {
    store.dispatch('user/refreshToken')
      .then(() => {
        loggedIn = (/true/i).test(store.getters['user/loggedIn']);

        if (loggedIn) {
          next ();
        } else {
          // alert('Su sesión ha expirado. Por favor, inicie sesión nuevamente.');
          next ('/login')
        }
      })
      .catch(() => {
        // alert('Su sesión ha expirado. Por favor, inicie sesión nuevamente.');
        next ('/login');
      });
  }
}

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      meta: { label: 'RegistrosPromocionales'},
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          // meta: { label: 'Inicio'},
          component: Dashboard,
          beforeEnter: requireAuth,
        },

        /* Staff */
        {
          path: 'staff',
          meta: { label: 'Staff'},
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'Staff',
              meta: { label: 'Staff'},
              component: Staff,
              beforeEnter: requireAuth,
            },
            {
              path: 'add',
              meta: { label: 'Informacion del Recurso'},
              name: 'StaffAdd',
              component: StaffAdd,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/edit',
              meta: { label: 'Informacion del Recurso'},
              name: 'StaffEdit',
              component: StaffEdit,
              beforeEnter: requireAuth,
            },
            {
              path: ':id',
              meta: { label: 'Informacion del Recurso'},
              name: 'StaffDatos',
              component: StaffDatos,
              beforeEnter: requireAuth,
            },

            // {
            //   path: ':id',
            //   meta: { label: 'Informacion de la Persona'},
            //   name: 'PersonaDatos',
            //   component: PersonaDatos,
            //   beforeEnter: requireAuth,
            // },
            // {
            //   path: ':id/ABM',
            //   meta: { label: 'Información de la Persona'},
            //   name: 'PersonaABM',
            //   component: PersonaABM,
            //   beforeEnter: requireAuth,
            // },
          ]
        },

        /* Eventos */
        {
          path: 'eventos',
          meta: { label: 'Eventos'},
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'Eventos',
              meta: { label: 'Listado de Eventos'},
              component: Eventos,
              beforeEnter: requireAuth,
            },
            {
              path: 'add',
              meta: { label: 'Información del Evento'},
              name: 'EventoAdd',
              component: EventoAdd,
              beforeEnter: requireAuth,
              props: { duplicar: false }
            },
            {
              path: ':id',
              meta: { label: 'Informacion del Evento'},
              name: 'EventoDatos',
              component: EventoDatos,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/edit',
              meta: { label: 'Información del Evento'},
              name: 'EventoEdit',
              component: EventoEdit,
              beforeEnter: requireAuth,
              props: { duplicar: false }
            },
            {
              path: ':id/duplicar',
              meta: { label: 'Información del Evento'},
              name: 'EventoDuplicar',
              component: EventoDuplicar,
              beforeEnter: requireAuth,
              props: { duplicar: true }
            },
            {
              path: ':id/codigos-promocion',
              meta: { label: 'Códigos de Promoción'},
              name: 'EventoCodigosPromocion',
              component: EventoCodigosPromocion,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/status',
              meta: { label: 'Status'},
              name: 'EventoStatus',
              component: EventoStatus,
              beforeEnter: requireAuth,
            },
            
            {
              path: ':eventoId/participantes',
              name: 'Participantes',
              meta: { label: 'Listado de Participantes'},
              component: Participantes,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/add',
              meta: { label: 'Informacion del Participante'},
              name: 'ParticipanteAdd',
              component: ParticipanteAdd,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/add-participacion',
              meta: { label: 'Informacion del Participante'},
              name: 'ParticipanteReinscripcion',
              component: ParticipanteReinscripcion,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/add-participacion/confirmacion',
              meta: { label: 'Informacion del Participante'},
              name: 'ParticipanteReinscripcionConfirmacion',
              component: ParticipanteReinscripcionConfirmacion,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/import',
              meta: { label: 'Listado de Imports'},
              name: 'ImportsParticipantes',
              component: ImportsParticipantes,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/import/:id',
              meta: { label: 'Información del Import'},
              name: 'ImportParticipantes',
              component: ImportParticipantes,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/import/:importParticipantesId/participantes/:id',
              meta: { label: 'Información del Import'},
              name: 'ImportParticipante',
              component: ImportParticipante,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/import/sorteo',
              meta: { label: 'Importación de Participantes'},
              name: 'ParticipantesSorteo',
              component: ParticipantesSorteo,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/:id',
              meta: { label: 'Informacion del Participante'},
              name: 'ParticipanteDatos',
              component: ParticipanteDatos,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/:id/edit',
              meta: { label: 'Información del Participante'},
              name: 'ParticipanteEdit',
              component: ParticipanteEdit,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/:id/etapa/:eventoEtapaId',
              meta: { label: 'Información del Participante - Etapa'},
              name: 'ParticipanteEtapa',
              component: ParticipanteEtapa,
              beforeEnter: requireAuth,
            },
            {
              path: ':eventoId/participantes/:participanteId/transferencia/:id',
              meta: { label: 'Información de la Autorizacion'},
              name: 'ParticipanteTransferenciaDatos',
              component: ParticipanteTransferenciaDatos,
              beforeEnter: requireAuth,
            },

            {
              path: ':eventoId/ganadores',
              meta: { label: 'Listado de Ganadores'},
              name: 'Ganadores',
              component: Ganadores,
              beforeEnter: requireAuth,
            },


            {
              path: ':eventoId/sorteo',
              name: 'ResultadosSorteo',
              meta: { label: 'Resultados del Sorteo'},
              component: ResultadosSorteo,
              beforeEnter: requireAuth,
            },
           
            {
              path: ':eventoId/etapas',
              meta: { label: 'Etapas'},
              component: {
                render (c) { return c('router-view') }
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: '',
                  name: 'EventosEtapas',
                  meta: { label: 'Listado de Etapas'},
                  component: EventosEtapas,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Información de la Etapa'},
                  name: 'EventoEtapaAdd',
                  component: EventoEtapaAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion de la Etapa'},
                  name: 'EventoEtapaDatos',
                  component: EventoEtapaDatos,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Informacion de la Etapa'},
                  name: 'EventoEtapaEdit',
                  component: EventoEtapaEdit,
                  beforeEnter: requireAuth,
                },
              ]
            },
            {
              path: ':id/proof',
              name: 'EventoProof',
              meta: { label: 'Proof del Evento'},
              component: EventoProof,
              beforeEnter: requireAuth,
            },
          ]
        },

        /* Sorteos Globales */
        {
          path: 'sorteos-globales',
          meta: { label: 'Sorteos Globales'},
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: '',
              name: 'SorteosGlobales',
              meta: { label: 'Listado de Sorteos Globales'},
              component: SorteosGlobales,
              beforeEnter: requireAuth,
            },
            {
              path: ':id/ABM',
              meta: { label: 'Información del Sorteo'},
              name: 'SorteoGlobalABM',
              component: SorteoGlobalABM,
              beforeEnter: requireAuth,
            },
            {
              path: ':id',
              meta: { label: 'Informacion del Sorteo'},
              name: 'SorteoGlobalDatos',
              component: SorteoGlobalDatos,
              beforeEnter: requireAuth,
            },
            {
              path: ':sorteoGlobalId/eventos',
              meta: { label: 'Eventos del Sorteo'},
              name: 'SorteoGlobalEventos',
              component: SorteoGlobalEventos,
              beforeEnter: requireAuth,
            },
            {
              path: ':sorteoGlobalId/sorteo',
              name: 'ResultadosSorteoGlobalSorteo',
              meta: { label: 'Resultados del Sorteo'},
              component: ResultadosSorteoGlobalSorteo,
              beforeEnter: requireAuth,
            },
          ]
        },

        /* EDI */
        {
          path: 'edi',
          meta: { label: 'Intercambio de Informacion'},
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: requireAuth,
          children: [
            /* Reportes de Transferencias */
            {
              path: 'transferencias',
              meta: { label: 'Transferencias'},
              component: {
                render (c) { return c('router-view') }
              },
              beforeEnter: requireAuth,
              children: [
                {
                  path: 'import',
                  meta: { label: 'Import'},
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: '',
                      name: 'ImportTransferenciasFile',
                      meta: { label: 'Import'},
                      component: ImportTransferenciasFile,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: 'transferencias',
                      name: 'ImportTransferenciasParticipantes',
                      meta: { label: 'Transferencias'},
                      component: ImportTransferenciasParticipantes,
                      beforeEnter: requireAuth,
                    },
                  ]
                },
                {
                  path: 'export',
                  meta: { label: 'Export'},
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: '',
                      name: 'ExportTransferencias',
                      meta: { label: 'Listado de Exports'},
                      component: ExportTransferencias,
                      beforeEnter: requireAuth,
                    },
                    {
                      path: ':id',
                      name: 'ExportTransferenciasDatos',
                      meta: { label: 'Información del Export'},
                      component: ExportTransferenciasDatos,
                      beforeEnter: requireAuth,
                    },
                  ]
                },
                {
                  path: 'montos-transferir',
                  meta: { label: 'Montos a Transferir'},
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: '',
                      name: 'ImportMontosTransferir',
                      meta: { label: 'Importar Montos a Transferir'},
                      component: ImportMontosTransferir,
                      beforeEnter: requireAuth,
                    },
                  ]
                },
              ]
            }
          ]
        },

        /* Tablas */
        {
          path: 'tablas',
          meta: { label: 'Tablas'},
          component: {
            render (c) { return c('router-view') }
          },
          beforeEnter: requireAuth,
          children: [
            {
              path: 'bancos',
              meta: { label: 'Bancos'},
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'Bancos',
                  meta: { label: 'Listado de Bancos'},
                  component: Bancos,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Informacion del Banco'},
                  name: 'BancoAdd',
                  component: BancoAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Informacion del Banco'},
                  name: 'BancoEdit',
                  component: BancoEdit,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id',
                  meta: { label: 'Informacion del Banco'},
                  name: 'BancoDatos',
                  component: BancoDatos,
                  beforeEnter: requireAuth,
                },
              ]
            },
            {
              path: 'clientes',
              meta: { label: 'Clientes'},
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  name: 'Clientes',
                  meta: { label: 'Listado de Clientes'},
                  component: Clientes,
                  beforeEnter: requireAuth,
                },
                {
                  path: 'add',
                  meta: { label: 'Informacion del Cliente'},
                  name: 'ClienteAdd',
                  component: ClienteAdd,
                  beforeEnter: requireAuth,
                },
                {
                  path: ':id/edit',
                  meta: { label: 'Informacion del Cliente'},
                  name: 'ClienteEdit',
                  component: ClienteEdit,
                  beforeEnter: requireAuth,
                },
              ]
            },
          ]
        },
        
        /* Seguridad */
        {
            path: 'seguridad',
            meta: { label: 'Seguridad'},
            component: {
              render (c) { return c('router-view') }
            },
            beforeEnter: requireAuth,
            children: [
              /* Usuarios */
              {
                path: 'usuarios',
                meta: { label: 'Usuarios'},
                component: {
                  render (c) { return c('router-view') }
                },
                beforeEnter: requireAuth,
                children: [
                  {
                    path: '',
                    name: 'Usuarios',
                    meta: { label: 'Listado de Usuarios'},
                    component: Usuarios,
                    beforeEnter: requireAuth,
                  },
                  {
                    path: ':id',
                    meta: { label: 'Informacion del Usuario'},
                    name: 'UsuarioDatos',
                    component: UsuarioDatos,
                    beforeEnter: requireAuth,
                  },
                  {
                    path: ':id/ABM',
                    meta: { label: 'Información del Usuario'},
                    name: 'UsuarioABM',
                    component: UsuarioABM,
                    beforeEnter: requireAuth,
                  },
                ]
              },

              /* Usuario PWA */
              {
                path: 'pwa',
                name: 'UsuarioPWA',
                meta: { label: 'Actualizar Password PWA'},
                component: UsuarioPWA,
                beforeEnter: requireAuth,
              },

              /* Usuario Veraz */
              {
                path: 'veraz',
                name: 'UsuarioVeraz',
                meta: { label: 'Credenciales Veraz'},
                component: UsuarioVeraz,
                beforeEnter: requireAuth,
              },
            ]
        },
        {
          path: '/perfil',
          name: 'Perfil',
          component: Perfil,
          beforeEnter: requireAuth,
        },    
        {
          path: '/pwd',
          name: 'Pass',
          meta: { label: 'Actualización de la Contraseña'},
          component: Pass,
          beforeEnter: requireAuth,
        },    
        {
          path: '/search-result',
          name: 'SearchList',
          component: SearchList,
          beforeEnter: requireAuth,
        },
      ]
    },

    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    // {
    //   path: '/login-cliente',
    //   name: 'LoginCliente',
    //   component: LoginCliente,
    //   props: true
    // },
    {
      path: '/registro',
      name: 'Register',
      component: Register
    },
    {
      path: '/reset-pwd',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
  ]
})

export default router;